module.exports = __webpack_public_path__ + "static/media/blooming.cab60230.svg";